import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { KFM_WEB_USE_CHATBOT } from '@shared/constants/constants';
import { AuthService } from '@shared/authentication/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  private readonly _authService = inject(AuthService);

  public async start() {
    if (KFM_WEB_USE_CHATBOT) {
      this._authService.isAuthenticated$.subscribe(async (loginResponse) => {
        if (loginResponse && loginResponse.isAuthenticated) {
          const scriptLoaded = await this.initChatBot();

          if (scriptLoaded) {
            const script = document.createElement('script');
            script.src = 'assets/scripts/lib/chatbot.js';
            script.setAttribute('chatbot-url', environment.chatBotUrl);
            script.setAttribute(
              'access-token',
              loginResponse.accessToken ?? '',
            );
            script.async = true;
            document.body.appendChild(script);
          }
        }
      });
    }
  }

  private async initChatBot(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = environment.chatBotUrl + '/copilot/index.js';
      script.async = true;
      document.body.appendChild(script);
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        reject(false);
      };
    });
  }
}
